import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["onMousedown"]
const _hoisted_4 = ["onMousedown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "image-clip-handler",
    style: _normalizeStyle(_ctx.clipWrapperPositionStyle)
  }, [
    _createElementVNode("img", {
      class: "bottom-img",
      src: _ctx.src,
      draggable: false,
      alt: "",
      style: _normalizeStyle(_ctx.bottomImgPositionStyle)
    }, null, 12, _hoisted_1),
    _createElementVNode("div", {
      class: "top-image-content",
      style: _normalizeStyle({
        ..._ctx.topImgWrapperPositionStyle,
        clipPath: _ctx.clipPath,
      })
    }, [
      _createElementVNode("img", {
        class: "top-img",
        src: _ctx.src,
        draggable: false,
        alt: "",
        style: _normalizeStyle(_ctx.topImgPositionStyle)
      }, null, 12, _hoisted_2)
    ], 4),
    _createElementVNode("div", {
      class: "operate",
      style: _normalizeStyle(_ctx.topImgWrapperPositionStyle),
      onMousedown: _cache[0] || (_cache[0] = _withModifiers($event => _ctx.moveClipRange($event), ["stop"]))
    }, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['left-top', 'right-top', 'left-bottom', 'right-bottom'], (point) => {
        return _createElementVNode("div", {
          class: _normalizeClass(['clip-point', point, _ctx.rotateClassName]),
          key: point,
          onMousedown: _withModifiers($event => _ctx.scaleClipRange($event, point), ["stop"])
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            fill: "#fff",
            stroke: "#333"
          }, [
            _createElementVNode("path", {
              "stroke-width": "0.3",
              "shape-rendering": "crispEdges",
              d: "M 16 0 L 0 0 L 0 16 L 4 16 L 4 4 L 16 4 L 16 0 Z"
            })
          ], -1)
        ]), 42, _hoisted_3)
      }), 64)),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['top', 'bottom', 'left', 'right'], (point) => {
        return _createElementVNode("div", {
          class: _normalizeClass(['clip-point', point, _ctx.rotateClassName]),
          key: point,
          onMousedown: _withModifiers($event => _ctx.scaleClipRange($event, point), ["stop"])
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("svg", {
            width: "16",
            height: "16",
            fill: "#fff",
            stroke: "#333"
          }, [
            _createElementVNode("path", {
              "stroke-width": "0.3",
              "shape-rendering": "crispEdges",
              d: "M 16 0 L 0 0 L 0 4 L 16 4 Z"
            })
          ], -1)
        ]), 42, _hoisted_4)
      }), 64))
    ], 36)
  ], 4)), [
    [_directive_click_outside, _ctx.handleClip]
  ])
}